import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { OpenDirection } from './share.types';
import COLORS from '../../style/universal.color';
import FONTS from '../../style/fonts';

interface WrapperProps {
  openDirection: OpenDirection;
  fill?: string;
}

interface LabelProps {
  color?: string;
}

export const Label = styled(motion.button)<LabelProps>`
  background: transparent;
  border: 0;
  color: ${({ color }) => (color ? color : 'inherit')};
  font-family: ${FONTS.primaryFont};
  font-size: 1rem;
  margin: 0;
  padding: 0;
  position: absolute;
  right: 35px;
  top: 60%;
  transform: translateY(-50%);
  white-space: nowrap;

  &:hover {
    cursor: pointer;
  }
`;

export const Wrapper = styled.div<WrapperProps>`
  height: 30px;
  position: relative;
  width: 30px;

  .share-list {
    position: absolute;
    list-style: none;
    margin: 0;
    margin-left: 2px;
    padding: 0;

    &__item {
      position: absolute;
    }

    ${({ openDirection }) => {
      if (openDirection === 'down') {
        return css`
          margin-top: 10px;
        `;
        // TODO: This is a bug.
        // eslint-disable-next-line no-constant-condition
      } else if (openDirection === 'left' || 'right') {
        return css`
          margin-top: 3px;
          margin-right: 10px;
        `;
      }
      return '';
    }};
  }

  .share-button {
    position: absolute;
    top: 0;
    left: 0;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    &__close {
      top: 6px;
      left: 5px;
    }

    &__link {
      cursor: pointer;

      &--message {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        left: -105px;
        bottom: 2px;
        padding: 0 5px;
        border-radius: 5px;
        background: ${COLORS.libertyBlue};
        color: ${COLORS.mlbWhite};
        font-family: ${FONTS.primaryFont};
        font-size: 12px;

        &-icon {
          width: 10px;
          margin-right: 5px;
        }
      }
    }
  }

  .share-icon {
    width: 25px;
    cursor: pointer;
    &__button {
      background: none;
      border: none;
      padding: 0;
    }

    &__square {
      width: 30px;
    }

    &__close {
      width: 18px;
    }
  }
`;
